import Layout from "../static-layout/layout";
import { FromParameters as SliderFromParameters } from "./slider";
import { FromParameters as QuadrantFromParameters } from "./quadrant";
import { FromParameters as ContactUsFromParameters } from "./contact-us";
import { FromParameters as GalleryFromParameters } from "./gallery";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';

// NB: must match the parameters used in the server-side CMS entity in
// src/server/domain/entities/cms.php
export const templates = {
    slider: [ "imgs" ],
    quadrant: [ "ul_img", "ur_img", "ll_img", "lr_img", "ul_text", "ur_text", "ll_text", "lr_text" ],
    'contact-us': [ "img", "details" ],
    gallery: [ "imgs", "descriptions" ],
};

export default function Template({id, handleLayout=true}) {
    const [page, setPage] = useState(null);
    const alias = useParams().alias

    useEffect(() => {
        if (id === undefined && !alias) return;
        if (id !== undefined) {
            fetch(`/v1/api/pages/${id}`)
                .then(res => res.json())
                .then(data => setPage(data))
                .catch(err => console.error('Error fetching page:', err));
        } else if (alias) {
            fetch(`/v1/api/pages/${alias}`)
                .then(res => res.json())
                .then(data => setPage(data))
                .catch(err => console.error('Error fetching page by alias:', err));
        }
    }, [id, alias]);

    const layout = (children) => {
        let links = [];
        if (page && page.links) {
            links = page.links.map(link => ({
                href: `/v1/ui/page/${link}`,
                text: link,
            }));
        }
        links.push({
            href: "/v1/ui/staff/page/signin",
            text: "staff",
        });
        return handleLayout && page 
            ? <Layout links={links}>{children}</Layout> 
            : children;
    };

    if (!page) {
        return layout(<h1>Loading...</h1>);
    }

    switch (page.template) {
        case 'slider':
            return layout(<SliderFromParameters pageID={page.id} />);
        case 'quadrant':
            return layout(<QuadrantFromParameters pageID={page.id} />);
        case 'contact-us':
            return layout(<ContactUsFromParameters pageID={page.id} />);
        case 'gallery':
            return layout(<GalleryFromParameters pageID={page.id} />);
        default:
            return layout(<h1>Unknown page layout, please contact the administrator</h1>);
    }
}